import { useState, ReactNode } from "react"

import { ContentObjectItem } from "@vertesia/common"
import { motion } from "framer-motion"
import { X } from "lucide-react"

import { AdditionalDocumentsSelectionSearchPanel } from "@/features/report/AdditionalDocumentsSelectionSearchPanel"
import { Button } from "@ui/button"
import { REPORT_GENERATION_FACETS } from "@/constants/facets"
import { DocumentSearchProvider } from "@/plugins/providers/document/DocumentSearchProvider"

interface AdditionalDocumentsSelectionOverlayProps {
    children?: ReactNode
    onObjMultipleSelection: (documents: ContentObjectItem[]) => void
}
export function AdditionalDocumentsSelectionOverlay({ children, onObjMultipleSelection }: Readonly<AdditionalDocumentsSelectionOverlayProps>) {
    const [isOpen, setIsOpen] = useState(false)

    const handleOnMultipleSelection = (documents: ContentObjectItem[]) => {
        onObjMultipleSelection(documents)
        setIsOpen(false)
    }

    return (
        <div className="flex items-center justify-center">
            <div onClick={() => setIsOpen(true)} className="w-full align-left">
                {children}
            </div>
            {
                isOpen && (
                    <div className="z-60 fixed w-full inset-0 bg-opacity-50 flex justify-end top-0">
                        <motion.div
                            initial={{ y: "100%" }}
                            animate={{ y: 0 }}
                            exit={{ y: "0%" }}
                            transition={{ type: "spring", stiffness: 300, damping: 30 }}
                            className="w-80 h-full w-full bg-white shadow-lg p-0 relative"
                        >
                            <DocumentSearchProvider facets={REPORT_GENERATION_FACETS}>
                                <AdditionalDocumentsSelectionSearchPanel onMultipleSelection={handleOnMultipleSelection}>
                                    <Button
                                        onClick={() => setIsOpen(false)}
                                        variant="outline"
                                    >
                                        <X />
                                    </Button>
                                </AdditionalDocumentsSelectionSearchPanel>
                            </DocumentSearchProvider>
                        </motion.div>
                    </div>
                )
            }
        </div>
    )
}